import PropTypes from 'prop-types';
import { useState } from 'react';

import { useNavigate } from "react-router-dom";

import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

import { EditOutlined, ProfileOutlined, LogoutOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';
import {Auth} from "aws-amplify";
import {useDispatch} from "react-redux";
import {handlerResetStore} from "../../../../../store/reducer/reset_store";


const ProfileTab = ({ handleLogout }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  let navigate = useNavigate();
  const dispatch = useDispatch();
    const handleLogOut = () => {
        dispatch(handlerResetStore({}));
        Auth.signOut()
    }
  const handleListItemClick = (event, index) => {
      console.log(index)
      if (index===0){
          navigate('/profiles/user')
      }
    setSelectedIndex(index);
  };

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogOut}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;